import { Avatar, Box, Flex, Text } from "@chakra-ui/react";
import * as React from "react";
export interface ITicket {
  title: string;
  slug: string;
  description: string;
  price: number;
  isDeleted: boolean;
}
export const TicketDetails: React.FC<{ ticket: ITicket }> = ({ ticket }) => {
  return (
    <Box
      backgroundColor="white"
      borderRadius="lg"
      borderWidth="1px"
      padding="12px"
      marginBottom="10px"
    >
      <Flex flexDirection="row" flexGrow={1} flexWrap="wrap">
        <Flex
          flexDirection="column"
          flexGrow={1}
          width="100%"
          alignItems="center"
          paddingTop="10px"
          paddingBottom="10px"
        >
          <Avatar
            name={ticket?.title}
            size="xl"
            getInitials={(name) => {
              return name.charAt(0);
            }}
            marginTop="10px"
            marginBottom="10px"
          />
          <Text fontSize="2xl" fontWeight="bold">
            {ticket?.title}
          </Text>
          {/* <Text fontSize="md" fontWeight="semibold">
            {ticket?.description}
          </Text> */}
        </Flex>
        <Flex flexDirection="column" flexGrow={1}></Flex>
      </Flex>
    </Box>
  );
};
